import React, { useMemo } from 'react';

import { CodeLanguageContext } from '../../context/CodeLanguageContext';
import { useCodeBlocks } from '../../hooks/useCodeBlocks';
import { useCodeLanguage } from '../../hooks/useCodeLanguage';

interface Props {
  labels: string[];
}

export const MultiCodeBlock: React.FC<Props> = ({
  labels: codeBlockLabels,
  children,
}) => {
  const { codeBlocks, titles, labels } = useCodeBlocks(
    children,
    codeBlockLabels,
  );

  const [language, setLanguage] = useCodeLanguage({ languages: labels });

  if (!codeBlocks.length) {
    return children as React.ReactElement;
  }

  const value = useMemo(
    () => ({ labels, language, titles, setLanguage }),
    [labels, language, titles, setLanguage],
  );

  return (
    <CodeLanguageContext.Provider value={value}>
      {codeBlocks[language]}
    </CodeLanguageContext.Provider>
  );
};
